// src/utils/sanityQueries.js
import client from '../client';

// Função para embaralhar um array (algoritmo de Fisher-Yates)
function shuffleArray(array) {
    for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
    }
    return array;
}

export const getHomePageData = async () => {
    try {
        // Buscar banners aleatórios COM vídeo
        const bannerVideoQuery = `
            *[_type == "game" && defined(video.asset)] | order(_updatedAt desc) {
                _id,
                name,
                slug {
                    current
                },
                core,
                _updatedAt,
                logo {
                    asset->{
                        _id,
                        url
                    },
                    alt
                },
                box {
                    asset->{
                        _id,
                        url
                    },
                    alt
                },
                snap {
                    asset->{
                        _id,
                        url
                    },
                    alt
                },
                title {
                    asset->{
                        _id,
                        url
                    },
                    alt
                },
                video {
                    asset->{
                        _id,
                        url
                    }
                }
            }
        `;
        const bannerVideoData = await client.fetch(bannerVideoQuery);
        let bannerData = null;

        if (bannerVideoData && bannerVideoData.length > 0) {
            // Se houver vídeos, pega um aleatório
            bannerData = shuffleArray(bannerVideoData)[0];
        } else {
            // Se não houver vídeos, busca banners aleatórios COM snap
            const bannerSnapQuery = `
                *[_type == "game" && defined(snap.asset)] | order(_updatedAt desc) {
                    _id,
                    name,
                    slug {
                        current
                    },
                    core,
                    _updatedAt,
                    logo {
                        asset->{
                            _id,
                            url
                        },
                        alt
                    },
                    box {
                        asset->{
                            _id,
                            url
                        },
                        alt
                    },
                    snap {
                        asset->{
                            _id,
                            url
                        },
                        alt
                    },
                    title {
                        asset->{
                            _id,
                            url
                        },
                        alt
                    }
                    // Removido o vídeo daqui, pois estamos buscando os que têm snap
                }
            `;
            const bannerSnapData = await client.fetch(bannerSnapQuery);
            if (bannerSnapData && bannerSnapData.length > 0) {
                bannerData = shuffleArray(bannerSnapData)[0];
            }
        }

        // Buscar todos os jogos agrupados por core COM capa
        const allGamesQuery = `
            *[_type == "game" && defined(box.asset) ${bannerData?._id ? '&& _id != $bannerId' : ''}] {
                _id,
                name,
                slug {
                    current
                },
                core,
                _updatedAt,
                box {
                    asset->{
                        _id,
                        url
                    },
                    alt
                }
            }
        `;
        const allGamesParams = bannerData?._id ? { bannerId: bannerData._id } : {};
        const allGames = await client.fetch(allGamesQuery, allGamesParams);

        // Agrupar os jogos por core
        const jogosPorCore = allGames.reduce((acc, jogo) => {
            if (!acc[jogo.core]) {
                acc[jogo.core] = [];
            }
            acc[jogo.core].push(jogo);
            return acc;
        }, {});

        // Limitar a quantidade de jogos por core e embaralhar a ordem
        const coresLimitadas = Object.keys(jogosPorCore).reduce((acc, core) => {
            const jogosEmbaralhados = shuffleArray(jogosPorCore[core]);
            acc[core] = jogosEmbaralhados.slice(0, 24); // Exibe no máximo 24 jogos por core
            acc[core + '_total'] = jogosPorCore[core].length; // Adicionando o total de jogos por core
            return acc;
        }, {});

        // Encontrar a data da última modificação (a mais recente entre todos os jogos com capa e o banner, se existir)
        const allItems = [...allGames];
        if (bannerData) {
            allItems.push(bannerData);
        }
        const lastUpdated = allItems
            .filter(item => item && item._updatedAt)
            .reduce((latest, current) => {
                const currentUpdated = new Date(current._updatedAt).getTime();
                return latest > currentUpdated ? latest : currentUpdated;
            }, 0);

        return { banner: bannerData, cores: coresLimitadas, lastUpdated };
    } catch (error) {
        console.error("Erro ao buscar dados da página inicial:", error);
        return { banner: null, cores: {}, lastUpdated: null };
    }
};

export const getGameById = `
    *[_type == "game" && _id == $id] {
        _id,
        name,
        slug {
            current
        },
        core,
        file {
            asset->{
                _id,
                url
            },
        },
        box {
            asset->{
                _id,
                url
            },
        },
        background {
            asset->{
                _id,
                url
            },
        },
        // Removido o campo 'video' desta query
        // Adicione aqui outros campos que você queira exibir na página do jogo
    }[0]
`;

export const getAllGameSlugs = async () => {
    const query = `
        *[_type == "game" && defined(slug.current)][].slug.current
    `;
    try {
        const slugs = await client.fetch(query);
        return slugs.map(slug => ({ params: { slug } }));
    } catch (error) {
        console.error("Erro ao buscar slugs dos jogos:", error);
        return [];
    }
};

export const getGameBySlug = `
    *[_type == "game" && slug.current == $slug] {
        _id,
        name,
        slug {
            current
        },
        core,
        file {
            asset->{
                _id,
                url
            },
        },
        box {
            asset->{
                _id,
                url
            },
        },
        snap {
            asset->{
                _id,
                url
            },
        },
        background {
            asset->{
                _id,
                url
            },
        },
        // Removido o campo 'video' desta query
        // Adicione aqui outros campos que você queira exibir na página do jogo
    }[0]
`;

export const searchGames = async (searchTerm) => {
    const query = `
        *[_type == "game" && (name match $searchTerm || core match $searchTerm)] {
            _id,
            name,
            slug {
                current
            },
            core,
            box {
                asset->{
                    _id,
                    url
                },
            }
        }
    `;

    console.log("sanityQueries - Função searchGames chamada com o termo:", searchTerm);

    try {
        const results = await client.fetch(query, { searchTerm: `*${searchTerm}*` });
        console.log("sanityQueries - Resultados da query searchGames:", results);
        return results;
    } catch (error) {
        console.error("Erro ao buscar jogos:", error);
        return [];
    }
};

export const searchGamesInCoreWithPagination = async (coreSlug, searchTerm, page = 1, limit = 20) => {
    const skip = (page - 1) * limit;
    const query = `
        *[_type == "game" && core == $coreSlug && defined(box.asset) && name match $searchTerm] | order(name asc) [$skip...$limit] {
            _id,
            name,
            slug {
                current
            },
            box {
                asset->{
                    _id,
                    url
                },
                alt
            }
        }
    `;

    const countQuery = `
        count(*[_type == "game" && core == $coreSlug && defined(box.asset) && name match $searchTerm])
    `;

    try {
        const games = await client.fetch(query, { coreSlug, searchTerm: `*${searchTerm}*`, skip, limit: skip + limit });
        const total = await client.fetch(countQuery, { coreSlug, searchTerm: `*${searchTerm}*` });
        return { games, total };
    } catch (error) {
        console.error(`Erro ao buscar jogos do core "${coreSlug}" com busca e paginação:`, error);
        return { games: [], total: 0 };
    }
};

export const getGamesByCoreWithPagination = async (coreSlug, page = 1, limit = 20) => {
    const skip = (page - 1) * limit;
    const query = `
        *[_type == "game" && core == $coreSlug && defined(box.asset)] | order(name asc) [$skip...$limit] {
            _id,
            name,
            slug {
                current
            },
            box {
                asset->{
                    _id,
                    url
                },
                alt
            }
        }
    `;

    const countQuery = `
        count(*[_type == "game" && core == $coreSlug && defined(box.asset)])
    `;

    try {
        const games = await client.fetch(query, { coreSlug, skip, limit: skip + limit });
        const total = await client.fetch(countQuery, { coreSlug });
        return { games, total };
    } catch (error) {
        console.error(`Erro ao buscar jogos do core "${coreSlug}" com paginação:`, error);
        return { games: [], total: 0 };
    }
};